import React from "react";
import { useScrollReveal } from "../hooks/useScrollReveal";
import { personalInfo } from "../data/portfolio";

const Contact = () => {
  const { ref: headRef, isVisible: headVisible } = useScrollReveal({
    threshold: 0.2,
  });
  const { ref: contentRef, isVisible: contentVisible } = useScrollReveal({
    threshold: 0.1,
  });

  const socialLinks = [
    { label: "GitHub", key: "github", url: personalInfo.social.github },
    { label: "LinkedIn", key: "linkedin", url: personalInfo.social.linkedin },
  ];

  return (
    <section
      id="contact"
      className="py-24 md:py-36"
      style={{
        backgroundColor: "var(--color-bg)",
        borderTop: "1px solid var(--color-border)",
      }}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        {/* Header */}
        <div ref={headRef} className="mb-14 md:mb-20">
          <div
            className="section-label mb-6"
            style={{
              opacity: headVisible ? 1 : 0,
              transition: "opacity 0.5s ease",
            }}
          >
            05 / CONTACT
          </div>
          <h2
            className="font-bold leading-none tracking-tight mb-2"
            style={{
              fontSize: "clamp(2.5rem, 7vw, 6rem)",
              opacity: headVisible ? 1 : 0,
              transform: headVisible ? "translateY(0)" : "translateY(24px)",
              transition: "opacity 0.6s ease 0.1s, transform 0.6s ease 0.1s",
            }}
          >
            LET'S BUILD
          </h2>
          <h2
            className="font-bold leading-none tracking-tight mb-8"
            style={{
              fontSize: "clamp(2.5rem, 7vw, 6rem)",
              color: "var(--color-accent)",
              opacity: headVisible ? 1 : 0,
              transform: headVisible ? "translateY(0)" : "translateY(24px)",
              transition: "opacity 0.6s ease 0.2s, transform 0.6s ease 0.2s",
            }}
          >
            SOMETHING.
          </h2>

          <p
            className="text-base md:text-lg max-w-xl"
            style={{
              color: "var(--color-text2)",
              opacity: headVisible ? 1 : 0,
              transition: "opacity 0.5s ease 0.4s",
            }}
          >
            Have an idea worth building? A problem worth solving?{" "}
            <br className="hidden md:block" />
            Let's talk.
          </p>
        </div>

        <div 
          ref={contentRef}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12"
          style={{
            opacity: contentVisible ? 1 : 0,
            transform: contentVisible ? "translateY(0)" : "translateY(24px)",
            transition: "opacity 0.6s ease, transform 0.6s ease",
          }}
        >
          {/* Email */}
          <div>
            <div className="section-label mb-2">EMAIL</div>
            <a
              href={`mailto:${personalInfo.email}`}
              className="font-mono text-sm link-underline"
              style={{ color: "var(--color-text)" }}
            >
              {personalInfo.email}
            </a>
          </div>

          {/* Location */}
          <div>
            <div className="section-label mb-2">LOCATION</div>
            <span
              className="font-mono text-sm"
              style={{ color: "var(--color-text)" }}
            >
              {personalInfo.location}
            </span>
          </div>

          {/* Availability */}
          <div>
            <div className="section-label mb-2">STATUS</div>
            <div className="flex items-center gap-3">
              <span className="status-dot animate-pulse-dot" />
              <span
                className="font-mono text-sm"
                style={{ color: "var(--color-accent)" }}
              >
                AVAILABLE
              </span>
            </div>
          </div>

          {/* Social */}
          <div>
            <div className="section-label mb-4">FIND ME ON</div>
            <div className="flex flex-wrap gap-4">
              {socialLinks.map(({ label, url }) => (
                <a
                  key={label}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-mono text-xs px-4 py-2 transition-all duration-200"
                  style={{
                    border: "1px solid var(--color-border)",
                    color: "var(--color-text2)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = "var(--color-accent)";
                    e.currentTarget.style.color = "var(--color-accent)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = "var(--color-border)";
                    e.currentTarget.style.color = "var(--color-text2)";
                  }}
                >
                  {label} ↗
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Footer bottom */}
        <div
          className="mt-20 md:mt-28 pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4"
          style={{ borderTop: "1px solid var(--color-border)" }}
        >
          <div
            className="font-mono text-xs"
            style={{ color: "var(--color-text2)" }}
          >
            © {new Date().getFullYear()} {personalInfo.name} — Full Stack
            AI-Driven Engineer
          </div>
          <div
            className="font-mono text-xs"
            style={{ color: "var(--color-text2)" }}
          >
            {personalInfo.location}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
